import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycabhirecontractinhyderbad() {



  const cardData =
  {
    keyword: 'Monthly Cab Hire Contract in Hyderabad',
    heading: 'Aaryan Travels: Monthly Cab Hire Contract in Hyderabad',
    headingDescription: ' Aaryan Travels provides flexible Monthly Cab Hire Contract in Hyderabad for companies, corporate employees, factory workers, and frequent travelers who require dedicated transportation services. Whether you need a cab for daily office commute, staff pick-and-drop, vendor visits, or executive travel, our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures complete comfort and punctuality. With fixed monthly billing, professional chauffeurs, real-time tracking, and 24/7 support, we offer cost-effective long-term cab solutions without the hassle of daily bookings. From HITEC City to Banjara Hills, Secunderabad to Gachibowli, Aaryan Travels delivers dependable monthly cab rental plans across Hyderabad tailored to your schedule and budget.',

    top: 'Top Places to Visit in Hyderabad with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Charminar",
    "description": "Built in 1591 by Sultan Muhammad Quli Qutb Shah, Charminar is Hyderabad’s most iconic monument and symbol of the city. Its four towering minarets and Indo-Islamic architecture attract history lovers and photographers alike. The surrounding Laad Bazaar bustles with bangles, pearls, and street food. It looks breathtaking when illuminated at night. Charminar is Hyderabad’s eternal pride and cultural identity."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic hill fortress famous for its engineering marvels and acoustic design. Once the capital of the Golconda Sultanate, it guards tales of diamonds like the Kohinoor and Hope diamonds. Visitors enjoy sound-and-light shows that narrate its glorious history. The panoramic views from the top are stunning. Golconda is Hyderabad’s fortress of legends."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City holds the Guinness World Record as the world’s largest film studio complex. Spread over 2000 acres, it offers movie sets, theme parks, adventure zones, and entertainment shows. Tourists enjoy live performances, replica cities, and cinematic experiences. It is a paradise for families, photographers, and film lovers. Ramoji Film City is Hyderabad’s grand world of entertainment."
  },
  {
    "title": "Hussain Sagar Lake & Buddha Statue",
    "description": "Hussain Sagar is a heart-shaped lake connecting Hyderabad and Secunderabad. At its center stands a 58-feet tall monolithic Buddha statue on Gibraltar Rock. Boat rides during sunset offer mesmerizing views of the illuminated skyline. The Necklace Road and Tank Bund surrounding the lake are popular for evening strolls. Hussain Sagar is Hyderabad’s calm waterfront escape."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest art museums, showcasing artifacts collected by Mir Yousuf Ali Khan (Salar Jung III). It houses rare sculptures, clocks, paintings, and antiques from India, Europe, and Asia. The famous ‘Veiled Rebecca’ and musical clock attract crowds daily. Each gallery tells a unique story of global heritage. Salar Jung Museum is Hyderabad’s treasure house of art."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a serene white marble temple dedicated to Lord Venkateswara. Perched atop Naubat Pahad hill, it offers panoramic views of Hyderabad. The carvings showcase a mix of Dravidian, Rajasthani, and Utkala temple architecture. The temple glows beautifully in the evening lighting. Birla Mandir is Hyderabad’s peaceful spiritual haven."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace was the official residence of the Nizams and reflects regal Persian-Indian architecture. The palace complex features grand halls, chandeliers, courtyards, and vintage cars. The Khilwat Mubarak throne hall is the most majestic highlight. Weddings and cultural events are still held here. Chowmahalla Palace is Hyderabad’s royal grandeur preserved in time."
  },
  {
    "title": "Mecca Masjid",
    "description": "Mecca Masjid, one of India’s oldest and largest mosques, was built using bricks made from soil brought from Mecca. Its massive arches, domes, and prayer halls can accommodate thousands of worshippers. The peaceful ambiance and historic architecture draw people from all faiths. Pigeons often flock around its courtyard, adding tranquility. Mecca Masjid is Hyderabad’s sacred symbol of devotion."
  },
  {
    "title": "Nehru Zoological Park",
    "description": "Nehru Zoological Park is one of India’s largest and best-maintained zoos, home to tigers, lions, elephants, reptiles, and exotic birds. Safari rides and toy trains make it popular among children and families. The greenery and open enclosures create a natural wildlife experience. It is also an important center for animal conservation. Nehru Zoo is Hyderabad’s family-friendly nature retreat."
  },
  {
    "title": "Snow World",
    "description": "Snow World is India’s first and largest snow-themed amusement park, offering sub-zero fun in the middle of Hyderabad’s tropical weather. Visitors enjoy snow slides, ice skating, igloos, and artificial snowfall. Jackets and boots are provided for comfort and safety. It is a thrilling escape for all ages. Snow World is Hyderabad’s coolest entertainment zone."
  }
],


 "services": [
  {
    "name": "Monthly Cab Hire Contract in Hyderabad",
    "description": "Secure a reliable monthly cab hire contract in Hyderabad designed for individuals and businesses seeking long-term transportation solutions. Our service offers fixed monthly rates, priority bookings, and a wide selection of vehicles to match your commuting needs. Benefit from dedicated support, professional drivers, and flexible contract terms ensuring consistent, hassle-free travel throughout the month."
  },
  {
    "name": "Hyderabad Monthly Cab Rental",
    "description": "Our Hyderabad Monthly Cab Rental service provides affordable and convenient transportation for those requiring regular travel. Whether you are a corporate client, freelancer, or frequent traveler, choose from sedans, SUVs, and premium cars to enjoy a comfortable ride. Monthly rentals come with comprehensive maintenance, insurance coverage, and driver services tailored to your schedule."
  },
  {
    "name": "Long Term Cab Hire Hyderabad",
    "description": "Opt for our Long Term Cab Hire service in Hyderabad for extended transportation needs. Perfect for corporate employees, project teams, or family use, this service offers flexible rental durations, guaranteed vehicle availability, and cost-effective packages. Experience peace of mind with professional chauffeurs and well-maintained vehicles throughout your contract."
  },
  {
    "name": "Contract Cab Service Hyderabad",
    "description": "Our Contract Cab Service in Hyderabad is tailored for businesses and individuals looking for dependable, fixed-term transportation agreements. Enjoy priority access to cabs, customized billing, and dedicated customer support. This service is ideal for corporate fleets, event transportation, or regular commutes requiring reliability and consistency."
  },
  {
    "name": "Affordable Monthly Cabs Hyderabad",
    "description": "Get the best value with our Affordable Monthly Cabs service in Hyderabad, offering budget-friendly rates without compromising on vehicle quality or driver professionalism. Designed for daily commuters and small businesses, this service ensures clean, safe rides and flexible plans to suit your financial and travel requirements."
  },
  {
    "name": "Corporate Cab Contract Hyderabad",
    "description": "Simplify your company’s transportation with our Corporate Cab Contract service in Hyderabad. Tailored for businesses, this service includes invoicing options, priority bookings, and a fleet of executive vehicles. Benefit from chauffeur services, route optimization, and dedicated account management to streamline employee travel and corporate logistics."
  },
  {
    "name": "Chauffeur Monthly Cab Hyderabad",
    "description": "Experience convenience and professionalism with our Chauffeur Monthly Cab service in Hyderabad. Enjoy the luxury of dedicated drivers who are punctual, courteous, and familiar with the city's routes. Ideal for executives and busy professionals, this service ensures stress-free travel with a personal chauffeur at your service throughout the month."
  },
  {
    "name": "Self Drive Monthly Cab Hyderabad",
    "description": "Take control of your travel with our Self Drive Monthly Cab service in Hyderabad. Perfect for those who prefer driving themselves, we offer a range of well-maintained vehicles available on monthly rental contracts. Enjoy flexible mileage options, comprehensive insurance, and 24/7 roadside assistance to keep your journey smooth and safe."
  },
  {
    "name": "Hyderabad Sedan Cab Hire",
    "description": "Choose from a fleet of comfortable and stylish sedans for your monthly cab needs in Hyderabad. Our Sedan Cab Hire service offers air-conditioned, well-maintained vehicles suitable for individual and corporate use. Benefit from competitive monthly plans, professional drivers, and timely service to ensure a pleasant commuting experience."
  },
  {
    "name": "Monthly Taxi Agreement Hyderabad",
    "description": "Enter into a transparent and flexible Monthly Taxi Agreement in Hyderabad that caters to your transportation requirements. Our agreements cover vehicle maintenance, driver availability, and customizable terms to suit your business or personal needs. Enjoy peace of mind with consistent service, clear billing, and responsive customer care."
  },
  {
    "name": "Premium Cab Rental Hyderabad",
    "description": "Indulge in luxury with our Premium Cab Rental service available on a monthly basis in Hyderabad. Featuring high-end vehicles and professional chauffeurs, this service is perfect for corporate executives, VIP clients, and special occasions. Experience superior comfort, privacy, and exclusive amenities designed to elevate your travel experience."
  },
  {
    "name": "Flexible Monthly Cab Hyderabad",
    "description": "Our Flexible Monthly Cab service in Hyderabad offers adaptable rental plans that cater to changing travel needs. Whether you need to adjust the vehicle type, rental duration, or payment terms, we provide personalized solutions to fit your lifestyle or business demands. Benefit from hassle-free modifications and excellent customer support throughout your contract."
  },
  {
    "name": "Business Cab Service Hyderabad",
    "description": "Streamline your company’s transportation with our Business Cab Service in Hyderabad, offering dedicated monthly cab rentals for corporate teams. Enjoy reliable vehicles, professional drivers, and comprehensive billing solutions. Tailor your plan with options for airport transfers, client pickups, and daily office commutes to enhance business productivity."
  },
  {
    "name": "Monthly Cab Plan Hyderabad",
    "description": "Plan your monthly travel efficiently with our Monthly Cab Plan in Hyderabad, designed to provide regular, cost-effective rides with added benefits such as priority booking and loyalty rewards. This plan suits individuals and companies seeking dependable transportation without the hassle of daily bookings."
  },
  {
    "name": "Cab Subscription Hyderabad",
    "description": "Subscribe to hassle-free transportation with our Cab Subscription service in Hyderabad, offering monthly packages with fixed rates and guaranteed availability. Ideal for frequent travelers and corporate clients, this service ensures you always have a cab ready when you need it, along with premium service standards and easy online management."
  }
],
"tableData": [
  ["Monthly Cab Hire Contract in Hyderabad", "Hyderabad Monthly Cab Rental"],
  ["Long Term Cab Hire Hyderabad", "Contract Cab Service Hyderabad"],
  ["Affordable Monthly Cabs Hyderabad", "Corporate Cab Contract Hyderabad"],
  ["Chauffeur Monthly Cab Hyderabad", "Self Drive Monthly Cab Hyderabad"],
  ["Hyderabad Sedan Cab Hire", "Monthly Taxi Agreement Hyderabad"],
  ["Premium Cab Rental Hyderabad", "Flexible Monthly Cab Hyderabad"],
  ["Business Cab Service Hyderabad", "Monthly Cab Plan Hyderabad"],
  ["Cab Subscription Hyderabad", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Monthly Cab Hire Contracts in Hyderabad",
    "WhyChoosedescription": "Aaryan Travels offers flexible and trustworthy monthly cab hire services tailored to Hyderabad’s corporate and personal needs."
  },
  {
    "WhyChooseheading": "Consistent and Punctual Service Every Day",
    "WhyChoosedescription": "Our drivers ensure timely pickups and drops throughout the contract period, making your daily commute hassle-free."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cars designed for comfort and safety during long-term usage."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Hyderabad Routes",
    "WhyChoosedescription": "Our professional drivers know Hyderabad’s traffic patterns and best routes to ensure efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Monthly Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy clear and competitive monthly rates covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Coordination",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with scheduling and any travel adjustments."
  },
  {
    "WhyChooseheading": "Flexible Contract Terms to Suit Your Requirements",
    "WhyChoosedescription": "Choose contract durations and vehicle types that best fit your business or personal travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options for Individuals and Groups",
    "WhyChoosedescription": "Select from sedans, SUVs, or larger vehicles depending on your group size and comfort preferences."
  }
]



























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly cab hire contracts in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides flexible and cost-effective monthly cab hire contracts tailored for Hyderabad clients.',
  },
  {
    question: 'How can I book a monthly cab hire contract in Hyderabad with Aaryan Travels?',
    answer: 'You can book a monthly cab hire contract through our website, mobile app, or by contacting our corporate support team.',
  },
  {
    question: 'What types of vehicles are available for monthly cab hire contracts in Hyderabad?',
    answer: 'Aaryan Travels offers a range of vehicles including sedans, SUVs, and premium cars suitable for long-term hire.',
  },
  {
    question: 'Can monthly cab hire contracts in Hyderabad be customized according to business needs?',
    answer: 'Yes, we offer fully customizable monthly cab hire plans to suit your business requirements and employee commute schedules.',
  },
  {
    question: 'Are drivers assigned for monthly contracts experienced and reliable in Hyderabad?',
    answer: 'Absolutely. Our drivers are professional, trained, and familiar with Hyderabad routes and corporate standards.',
  },
  {
    question: 'Is there a monthly billing or invoice option for cab hire contracts in Hyderabad?',
    answer: 'Yes, Aaryan Travels provides convenient monthly billing and invoicing options for corporate clients.',
  },
  {
    question: 'Are safety and hygiene protocols followed during monthly cab hire in Hyderabad?',
    answer: 'Yes, all vehicles undergo regular sanitization and drivers follow strict safety protocols for passenger protection.',
  },
  {
    question: 'Is Aaryan Travels monthly cab hire service in Hyderabad available 24x7?',
    answer: 'Yes, our monthly cab hire services operate round the clock to meet your business travel needs.',
  },
  {
    question: 'What payment methods are accepted for monthly cab hire contracts in Hyderabad?',
    answer: 'We accept cash, digital wallets, UPI, credit/debit cards, and bank transfers for hassle-free payments.',
  },
  {
    question: 'Can pickup and drop-off locations be customized in monthly cab hire contracts in Hyderabad?',
    answer: 'Yes, Aaryan Travels allows full customization of pickup and drop points for monthly cab hire contracts.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Reddy',
    feedback: 'Aaryan Travels’ monthly cab hire contract in Hyderabad has streamlined our employee transportation with great professionalism.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Kapoor',
    feedback: 'Excellent monthly cab hire service by Aaryan Travels in Hyderabad. Reliable, punctual, and very supportive team.',
    rating: 5,
  },
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Cab Hire Contract in Hyderabad",
  "image": "https://aaryantravels.com/assets/images/monthly-cab-hyderabad.jpg", // replace with actual image URL
  "description": "Flexible and affordable monthly cab hire contracts in Hyderabad. Ideal for corporate clients, long-term rentals, chauffeur-driven and self-drive options. Book your monthly cab plan with Aaryan Travels for hassle-free transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // example rating, update as needed
    "ratingCount": "3200", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",  // example monthly price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/monthly-cab-hire-hyderabad"
  }
};






  return (
    <div>


<Helmet>
  <title>Monthly Cab Hire Contract in Hyderabad | Corporate & Flexible Plans | Aaryan Travels</title>
  <meta
    name="description"
    content="Flexible and affordable monthly cab hire contracts in Hyderabad. Ideal for corporate clients, long-term rentals, chauffeur-driven and self-drive options. Book your monthly cab plan with Aaryan Travels for hassle-free transportation."
  />
  <meta
    name="keywords"
    content="Monthly Cab Hire Contract in Hyderabad, Hyderabad Monthly Cab Rental, Long Term Cab Hire Hyderabad, Contract Cab Service Hyderabad, Affordable Monthly Cabs Hyderabad, Corporate Cab Contract Hyderabad, Chauffeur Monthly Cab Hyderabad, Self Drive Monthly Cab Hyderabad, Hyderabad Sedan Cab Hire, Monthly Taxi Agreement Hyderabad, Premium Cab Rental Hyderabad, Flexible Monthly Cab Hyderabad, Business Cab Service Hyderabad, Monthly Cab Plan Hyderabad, Cab Subscription Hyderabad"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/6.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycabhirecontractinhyderbad;